export default "__VITE_ASSET__B9qG03L0__"